import MoveWizardStep2 from './move-wizard-step-2';
export default MoveWizardStep2;
